import { defineStore } from 'pinia';
import { fetchApiKeys, createApiKey, updateApiKey, deleteApiKey } from "@/services/ppApi";
import { useAccountStore } from '@/stores/account';

export const useApiKeysStore = defineStore('apiKeys', {
    state: () => {
        return {
            apiKeys: [],
            loading: false,
            error: null,
            found: 0
        }
    },
    actions: {
        resetApiKeys() {
            this.$reset();
        },
        async fetchApiKeys() {
            this.loading = true;
            this.error = null;

            try {
                const params = {
                    account_id: useAccountStore().account.account_id   
                };

                const response = await fetchApiKeys(params);
                this.apiKeys = response.data.api_key;
                this.found = response.data.found;
            } catch (error) {
                this.apiKeys = [];
                this.found = 0;
                this.error = error;
            } finally {
                this.loading = false;
            }
        },
        async createApiKey(apiKey) {
            try {
                const response = await createApiKey(apiKey);

                if(response.status >= 200 && response.status < 300) {
                    const newApiKey = response.data.api_key[0];
                    this.apiKeys.unshift(newApiKey);
                    return newApiKey;
                } else {
                    return false;
                }
            } catch (error) {
                return false;
            }
        },
        async updateApiKey(apiKey) {
            try {
                if(apiKey.api_key) delete apiKey.api_key;
                if(apiKey.key_created_by) delete apiKey.key_created_by;
                if(apiKey.inserted_date) delete apiKey.inserted_date;

                const response = await updateApiKey(apiKey);
                let updatedApiKey = response.data.api_key[0];
                if(!updatedApiKey.api_key_part) return false;
        
                const index = this.apiKeys.findIndex(existingApiKey => existingApiKey.api_key_part === updatedApiKey.api_key_part);
                if (index !== -1) {
                    this.apiKeys[index] = { ...this.apiKeys[index], ...updatedApiKey };
                } else {
                    this.apiKeys.push(updatedApiKey);
                }
                return true;
            } catch (error) {
                return false;
            }
        },
        async deleteApiKey(apiKey) {
            try {
                if(apiKey.api_key) delete apiKey.api_key;
                if(apiKey.key_created_by) delete apiKey.key_created_by;
                if(apiKey.inserted_date) delete apiKey.inserted_date;

                await deleteApiKey(apiKey);
                this.apiKeys = this.apiKeys.filter(existingApiKey => existingApiKey.api_key_part !== apiKey.api_key_part);
                return true;
            } catch (error) {
                return false;
            }
        },
    }
});
